import React, { useEffect, useRef, useState } from 'react';
import LessonChip from './LessonChip';
import styles from './DayPopup.module.css';

function DayPopup({ date, lessons, holiday, onLessonClick, onAddLesson, onClose, onAddCustomDay, onRemoveCustomDay }) {
  const popupRef = useRef(null);
  const [showCustomForm, setShowCustomForm] = useState(false);
  const [customName, setCustomName] = useState('');

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const formatted = date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });

  const handleAddCustom = () => {
    if (customName.trim()) {
      onAddCustomDay(date, customName.trim());
      setShowCustomForm(false);
      setCustomName('');
    }
  };

  return (
    <>
      <div className={styles.overlay} onClick={onClose} />
      <div className={styles.popup} ref={popupRef}>
        <div className={styles.header}>
          <h3 className={styles.title}>{formatted}</h3>
          <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {holiday && (
          <div className={styles.holidayBanner}>
            <span className={styles.holidayEmoji}>{holiday.emoji}</span>
            <span className={styles.holidayLabel}>{holiday.name}</span>
            {holiday.type === 'custom' && (
              <button
                className={styles.removeHolidayBtn}
                onClick={() => onRemoveCustomDay(holiday.id)}
              >
                Remove
              </button>
            )}
          </div>
        )}

        <div className={styles.body}>
          {lessons.length > 0 ? (
            <div className={styles.lessonsList}>
              {lessons.map((lesson) => (
                <div
                  key={lesson.id}
                  className={styles.lessonItem}
                  onClick={() => onLessonClick(lesson)}
                >
                  <LessonChip lesson={lesson} onClick={onLessonClick} />
                </div>
              ))}
            </div>
          ) : (
            <p className={styles.empty}>No lessons scheduled for this day.</p>
          )}
          <button className={styles.addBtn} onClick={onAddLesson}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
            Add Lesson
          </button>

          {!holiday && (
            <>
              {showCustomForm ? (
                <div className={styles.customDayForm}>
                  <input
                    className={styles.customDayInput}
                    type="text"
                    placeholder="e.g. Teacher In-Service"
                    value={customName}
                    onChange={(e) => setCustomName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleAddCustom()}
                    autoFocus
                    maxLength={200}
                  />
                  <div className={styles.customDayActions}>
                    <button className={styles.customDaySave} onClick={handleAddCustom}>Save</button>
                    <button className={styles.customDayCancel} onClick={() => { setShowCustomForm(false); setCustomName(''); }}>Cancel</button>
                  </div>
                </div>
              ) : (
                <button className={styles.markDayBtn} onClick={() => setShowCustomForm(true)}>
                  Mark as non-school day
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default DayPopup;
